/**
 * @generated SignedSource<<bdbf1c68bdb9fcdc0c5000295acc788f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type UserReviewRating = "RATING_ATTENTION_TO_DETAIL" | "RATING_CLARITY_OF_PROJECT_REQUIREMENTS" | "RATING_COMMUNICATION" | "RATING_PROFESSIONALISM" | "RATING_QUALITY_OF_WORK" | "RATING_RESPONSIVENESS" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AverageCompanyReviewScoreBreakdown_organization$data = {
  readonly averageReviewScores: {
    readonly averageTotal: number | null;
    readonly categories: ReadonlyArray<{
      readonly id: string;
      readonly nid: UserReviewRating;
      readonly rating: number;
    }> | null;
  } | null;
  readonly slug: string | null;
  readonly userReviews: {
    readonly count: number;
  };
  readonly " $fragmentType": "AverageCompanyReviewScoreBreakdown_organization";
};
export type AverageCompanyReviewScoreBreakdown_organization$key = {
  readonly " $data"?: AverageCompanyReviewScoreBreakdown_organization$data;
  readonly " $fragmentSpreads": FragmentRefs<"AverageCompanyReviewScoreBreakdown_organization">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AverageCompanyReviewScoreBreakdown_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AverageReviewScores",
      "kind": "LinkedField",
      "name": "averageReviewScores",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "averageTotal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AverageReviewScoreCategory",
          "kind": "LinkedField",
          "name": "categories",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "nid",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rating",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserReviewConnection",
      "kind": "LinkedField",
      "name": "userReviews",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node as any).hash = "7cd23f7243d248a996024c13bcf26115";

export default node;
